// import React, { useState, useEffect } from "react";
// import "./registrationfrom.css";
// import Swal from "sweetalert2";
// import Address from "./Address";
// import JobDetails from "./JobDetails";
// import CustomFields from "./CustomFields";
// import PersonalInfo from "./PersonalInfo";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import Cropper from 'react-easy-crop';

// function EmployeeRegistration(dataClient) {
//   const [personalInfo, setPersonalInfo] = useState({});
//   const [address, setAddress] = useState({});
//   const [jobDetails, setJobDetails] = useState({});

//   const user_name = dataClient.dataClient?.client_schema_name[6][0].user_name;

//   // const handleSubmit = async () => {
//   //   try {
//   //     if (!validateForm()) {
//   //       throw new Error("Please fill all required fields");
//   //     }

//   //     const formData = {
//   //       client_id: 1,
//   //       client_branch_id: 1,
//   //       age_as_on: new Date().toISOString(),
//   //       landline: null,
//   //       signature: null,
//   //       delete_flag: null,
//   //       last_modified_date: new Date().toISOString(),
//   //       last_modified_by: user_name,
//   //       create_date: new Date().toISOString(),
//   //       created_by: user_name,
//   //       last_modified_screen_id: 1,
//   //       ...personalInfo,
//   //       ...address,
//   //       ...jobDetails,
//   //     };

//   //     console.log(formData, "formData");
//   //     const response = await fetch(
//   //       `${FULL_API_BASE_URL}/new-employee`,
//   //       {
//   //         method: "POST",
//   //         headers: {
//   //           "Content-Type": "application/json",
//   //         },
//   //         body: JSON.stringify(formData),
//   //       }
//   //     );

//   //     if (!response.ok) {
//   //       throw new Error("Failed to submit form");
//   //     }

//   //     const responseData = await response.json();

//   //     if (responseData.result === "success") {
//   //       Swal.fire({
//   //         title: "Success",
//   //         text: responseData.message,
//   //         icon: "success",
//   //         confirmButtonColor: "#318682",
//   //       });
//   //       resetForm();
//   //     } else {
//   //       Swal.fire({
//   //         title: "Failed to register",
//   //         text: responseData.message,
//   //         icon: "warning",
//   //         confirmButtonColor: "#318682",
//   //       });
//   //     }
//   //   } catch (error) {
//   //     Swal.fire({
//   //       title: "Error in submitting the form",
//   //       text: error.message,
//   //       icon: "error",
//   //       confirmButtonColor: "rgb(100 101 101)",
//   //     });
//   //   }
//   // };

//   // const handleSubmit = async () => {
//   //   try {
//   //     const validationErrors = validateForm();
//   //     if (validationErrors.length > 0) {
//   //       throw new Error(validationErrors.join("\n"));
//   //     }

//   //     const formData = {
//   //       client_id: 1,
//   //       client_branch_id: 1,
//   //       age_as_on: new Date().toISOString(),
//   //       landline: null,
//   //       signature: null,
//   //       delete_flag: null,
//   //       last_modified_date: new Date().toISOString(),
//   //       last_modified_by: user_name,
//   //       create_date: new Date().toISOString(),
//   //       created_by: user_name,
//   //       last_modified_screen_id: 1,
//   //       ...personalInfo,
//   //       ...address,
//   //       ...jobDetails,
//   //     };

//   //     console.log(formData, "formData");
//   //     const response = await fetch(
//   //       `${FULL_API_BASE_URL}/new-employee`,
//   //       {
//   //         method: "POST",
//   //         headers: {
//   //           "Content-Type": "application/json",
//   //         },
//   //         body: JSON.stringify(formData),
//   //       }
//   //     );

//   //     if (!response.ok) {
//   //       throw new Error("Failed to submit form");
//   //     }

//   //     const responseData = await response.json();

//   //     if (responseData.result === "success") {
//   //       Swal.fire({
//   //         title: "Success",
//   //         text: responseData.message,
//   //         icon: "success",
//   //         confirmButtonColor: "#318682",
//   //       });
//   //       resetForm();
//   //     } else {
//   //       Swal.fire({
//   //         title: "Failed to register",
//   //         text: responseData.message,
//   //         icon: "warning",
//   //         confirmButtonColor: "#318682",
//   //       });
//   //     }
//   //   } catch (error) {
//   //     Swal.fire({
//   //       title: "Error in submitting the form",
//   //       text: error.message,
//   //       icon: "error",
//   //       confirmButtonColor: "rgb(100 101 101)",
//   //     });
//   //   }
//   // };

//   const handleSubmit = async () => {
//     try {
//       const validationErrors = validateForm();
//       if (validationErrors.length > 0) {
//         throw new Error(validationErrors.join("\n"));
//       }

//       // Create FormData object
//       const formData = new FormData();

//       // Add the image if it exists
//       if (personalInfo.IMG) {
//         formData.append('IMG', personalInfo.IMG);
//       }

//       // Add other form data
//       const otherData = {
//         client_id: 1,
//         client_branch_id: 1,
//         age_as_on: new Date().toISOString(),
//         landline: null,
//         signature: null,
//         delete_flag: null,
//         last_modified_date: new Date().toISOString(),
//         last_modified_by: user_name,
//         create_date: new Date().toISOString(),
//         created_by: user_name,
//         last_modified_screen_id: 1,
//         ...personalInfo,
//         ...address,
//         ...jobDetails,
//       };

//       // Remove IMG from otherData as it's already added to FormData
//       delete otherData.IMG;

//       // Append the rest of the data as a JSON string
//       formData.append('data', JSON.stringify(otherData));

//       const response = await fetch(
//         `${FULL_API_BASE_URL}/new-employee`,
//         {
//           method: 'POST',
//           body: formData,
//         }
//       );

//       if (!response.ok) {
//         throw new Error('Failed to submit form');
//       }

//       const responseData = await response.json();

//       if (responseData.result === 'success') {
//         Swal.fire({
//           title: 'Success',
//           text: responseData.message,
//           icon: 'success',
//           confirmButtonColor: '#318682',
//         });
//         resetForm();
//       } else {
//         Swal.fire({
//           title: 'Failed to register',
//           text: responseData.message,
//           icon: 'warning',
//           confirmButtonColor: '#318682',
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         title: 'Error in submitting the form',
//         text: error.message,
//         icon: 'error',
//         confirmButtonColor: 'rgb(100 101 101)',
//       });
//     }
//   };

//   const validateForm = () => {
//     const errors = [];

//     if (!personalInfo.salutation_id) errors.push("Salutation is required.");
//     if (personalInfo.gender_id === null) errors.push("Gender is required.");
//     if (!personalInfo.blood_group_id) errors.push("Blood group is required.");
//     if (!personalInfo.religion_id) errors.push("Religion is required.");
//     if (personalInfo.category_id === 0) errors.push("Category is required.");
//     if (!personalInfo.emp_first_name) errors.push("First name is required.");
//     if (!personalInfo.emp_last_name) errors.push("Last name is required.");
//     if (!personalInfo.age) errors.push("Age is required.");
//     if (personalInfo.married_flag === null) errors.push("Marital status is required.");
//     if (!personalInfo.fathers_name) errors.push("Father's name is required.");

//     if (!address.loc_add1) errors.push("Local address is required.");
//     if (address.loc_city_id === null) errors.push("Local city is required.");
//     if (!address.perm_add1) errors.push("Permanent address is required.");
//     if (!address.perm_city_id) errors.push("Permanent city is required.");
//     if (address.prim_mob_no === null) errors.push("Primary mobile number is required.");

//     if (!jobDetails.staff_number) errors.push("Staff number is required.");
//     if (!jobDetails.hire_date) errors.push("Hire date is required.");
//     if (jobDetails.department_id === null) errors.push("Department is required.");
//     if (jobDetails.grade_id === null) errors.push("Grade is required.");
//     if (jobDetails.designation_id === null) errors.push("Designation is required.");
//     if (!jobDetails.emp_type) errors.push("Employee type is required.");
//     if (!jobDetails.status) errors.push("Status is required.");
//     if (jobDetails.manager_emp_id === null) errors.push("Manager Employee ID is required.");

//     return errors;
//   };
//   // const validateForm = () => {
//   //   // Check if all required fields have personalInfo
//   //   if (
//   //     personalInfo.salutation_id === "" ||
//   //     personalInfo.gender_id === null ||
//   //     personalInfo.blood_group_id === "" ||
//   //     personalInfo.religion_id === "" ||
//   //     personalInfo.category_id === 0 ||
//   //     personalInfo.emp_first_name === "" ||
//   //     personalInfo.emp_last_name === "" ||
//   //     personalInfo.age === "" ||
//   //     personalInfo.married_flag === null ||
//   //     PersonalInfo.fathers_name === "" ||
//   //     address.loc_add1 === "" ||
//   //     address.loc_city_id === null ||
//   //     address.perm_add1 === "" ||
//   //     address.perm_city_id === "" ||
//   //     address.prim_mob_no === null ||
//   //     jobDetails.staff_number === "" ||
//   //     jobDetails.hire_date === "" ||
//   //     jobDetails.department_id === null ||
//   //     jobDetails.grade_id === null ||
//   //     jobDetails.designation_id === null ||
//   //     jobDetails.emp_type === "" ||
//   //     jobDetails.status === "" ||
//   //     jobDetails.manager_emp_id === null
//   //   ) {
//   //     return false;
//   //   }
//   //   return true;
//   // };

//   const handleCancel = () => {
//     Swal.fire({
//       title: "Are you sure you want to cancel?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes",
//       cancelButtonText: "No",
//       confirmButtonColor: "rgb(100 101 101)",
//       cancelButtonColor: "#318682",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         resetForm();
//       }
//     });
//   };

//   const resetForm = () => {
//     setPersonalInfo({});
//     setJobDetails({});
//     setAddress({});
//     setTimeout(() => {
//       window.location.reload();
//     }, 1000);
//   };

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-one">
//         <span className="create-role-heading">Employee Registration Form</span>
//         <div className="cr-header-btn-container">
//           <button className="cr-cancel-btn" onClick={handleCancel}>
//             CANCEL
//           </button>
//           <button className="cr-create-btn" onClick={handleSubmit} style={{backgroundColor: "#424342", color: "white"}}>
//             SAVE
//           </button>
//         </div>
//       </div>

//       <PersonalInfo setPersonalInfo={setPersonalInfo} />
//       <Address setAddress={setAddress} />
//       <JobDetails setJobDetails={setJobDetails} />
//       <CustomFields />
//     </div>
//   );
// }
// export default EmployeeRegistration;

import React, { useState, useEffect } from "react";
import "./registrationfrom.css";
import Swal from "sweetalert2";
import Address from "./Address";
import JobDetails from "./JobDetails";
import CustomFields from "./CustomFields";
import PersonalInfo from "./PersonalInfo";
import InterogativeImg from "../../Assets/Images/CommanImages/Informative.png";
import WarnningIcon from "../../Assets/Images/CommanImages/Warning.png";
import { FULL_API_BASE_URL } from "../../Config/Config";
import Cropper from "react-easy-crop";

function EmployeeRegistration({
  dataClient,
  setMessageBox,
  messageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  setNoTimeSet,
  setMessageBoxHeight,
}) {
  const [personalInfo, setPersonalInfo] = useState({});
  const [address, setAddress] = useState({});
  const [jobDetails, setJobDetails] = useState({});

  const user_name = dataClient?.client_schema_name[6][0].user_name;
  const client_id = dataClient?.client_schema_name[6][0].client_id;
  const client_branch_id =
    dataClient?.client_schema_name[6][0].client_branch_id;

  // const handleSubmit = async () => {
  //   try {
  //     const validationErrors = validateForm();
  //     if (validationErrors.length > 0) {
  //       throw new Error(validationErrors.join("\n"));
  //     }

  //     const formData = new FormData();

  //     // Append image or empty blob
  //     if (personalInfo.IMG) {
  //       formData.append("photograph", personalInfo.IMG);
  //     } else {
  //       const emptyFile = new Blob([""], { type: "image/png" }); // or "image/jpeg"
  //       formData.append("photograph", emptyFile, "empty.png");
  //     }

  //     const employeePayload = {
  //       client_id: client_id,
  //       client_branch_id: client_branch_id,
  //       age_as_on: new Date().toISOString(),
  //       landline: null,
  //       signature: null,
  //       delete_flag: null,
  //       last_modified_date: new Date().toISOString(),
  //       last_modified_by: user_name,
  //       create_date: new Date().toISOString(),
  //       created_by: user_name,
  //       last_modified_screen_id: 1,
  //       ...personalInfo,
  //       ...address,
  //       ...jobDetails,
  //     };

  //     delete employeePayload.IMG;

  //     formData.append("employee_data", JSON.stringify(employeePayload));

  //     const response = await fetch(
  //       `${FULL_API_BASE_URL}/new-employee`,
  //       {
  //         method: "POST",
  //         body: formData,
  //       }
  //     );

  //     const responseData = await response.json();

  //     if (response.ok && responseData.result === "success") {
  //       Swal.fire({
  //         title: "Success",
  //         text: responseData.message,
  //         icon: "success",
  //         confirmButtonColor: "#318682",
  //       });
  //       resetForm();
  //     } else {
  //       Swal.fire({
  //         title: "Failed to register",
  //         text: responseData.message || "Something went wrong.",
  //         icon: "warning",
  //         confirmButtonColor: "#318682",
  //       });
  //     }
  //   } catch (error) {
  //     Swal.fire({
  //       title: "Error in submitting the form",
  //       text: error.message,
  //       icon: "error",
  //       confirmButtonColor: "rgb(100 101 101)",
  //     });
  //   }
  // };

  // const handleSubmit = async () => {
  //   try {
  //     const validationErrors = validateForm();
  //     if (validationErrors.length > 0) {
  //       throw new Error(validationErrors.join("\n"));
  //     }

  //     // Create FormData object
  //     const formData = new FormData();

  //     // Add the image if it exists
  //     if (personalInfo.IMG) {
  //       formData.append('IMG', personalInfo.IMG);
  //     }

  //     // Add other form data
  //     const otherData = {
  //       client_id: 1,
  //       client_branch_id: 1,
  //       age_as_on: new Date().toISOString(),
  //       landline: null,
  //       signature: null,
  //       delete_flag: null,
  //       last_modified_date: new Date().toISOString(),
  //       last_modified_by: user_name,
  //       create_date: new Date().toISOString(),
  //       created_by: user_name,
  //       last_modified_screen_id: 1,
  //       ...personalInfo,
  //       ...address,
  //       ...jobDetails,
  //     };

  //     // Remove IMG from otherData as it's already added to FormData
  //     delete otherData.IMG;

  //     // Append the rest of the data as a JSON string
  //     formData.append('data', JSON.stringify(otherData));

  //     const response = await fetch(
  //       `${FULL_API_BASE_URL}/new-employee`,
  //       {
  //         method: 'POST',
  //         body: formData,
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error('Failed to submit form');
  //     }

  //     const responseData = await response.json();

  //     if (responseData.result === 'success') {
  //       Swal.fire({
  //         title: 'Success',
  //         text: responseData.message,
  //         icon: 'success',
  //         confirmButtonColor: '#318682',
  //       });
  //       resetForm();
  //     } else {
  //       Swal.fire({
  //         title: 'Failed to register',
  //         text: responseData.message,
  //         icon: 'warning',
  //         confirmButtonColor: '#318682',
  //       });
  //     }
  //   } catch (error) {
  //     Swal.fire({
  //       title: 'Error in submitting the form',
  //       text: error.message,
  //       icon: 'error',
  //       confirmButtonColor: 'rgb(100 101 101)',
  //     });
  //   }
  // };

  const handleSubmit = async () => {
    try {
      const validationErrors = validateForm();

      if (validationErrors.length > 0) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <div style={{ fontWeight: 600, marginBottom: 6 }}></div>
              <span> {validationErrors}</span>
            </div>
          </div>
        );
        setActiveImg(WarnningIcon);
        setMessageBoxHeight("auto");
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }

      const formData = new FormData();

      if (personalInfo.IMG) {
        formData.append("photograph", personalInfo.IMG);
      } else {
        const emptyFile = new Blob([""], { type: "image/png" });
        formData.append("photograph", emptyFile, "empty.png");
      }

      const employeePayload = {
        client_id,
        client_branch_id,
        age_as_on: new Date().toISOString(),
        landline: null,
        signature: null,
        delete_flag: null,
        last_modified_date: new Date().toISOString(),
        last_modified_by: user_name,
        create_date: new Date().toISOString(),
        created_by: user_name,
        last_modified_screen_id: 1,
        ...personalInfo,
        ...address,
        ...jobDetails,
      };
      delete employeePayload.IMG;

      formData.append("employee_data", JSON.stringify(employeePayload));

      const response = await fetch(`${FULL_API_BASE_URL}/new-employee`, {
        method: "POST",
        body: formData,
      });
      const responseData = await response.json();

      if (response.ok && responseData.result === "success") {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{responseData.message || "Employee registered."}</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{responseData.message || "Failed to register."}</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
        setMessageBoxHeight("10vh");
      }
    } catch (error) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{error.message}</span>
          </div>
        </div>
      );
      setActiveImg(InterogativeImg);
      setMessageBoxHeight("10vh");
    }
  };

  const validateForm = () => {
    const errors = [];

    if (!personalInfo.salutation_id) errors.push("Salutation is required.");
    if (personalInfo.gender_id === null) errors.push("Gender is required.");
    if (!personalInfo.blood_group_id) errors.push("Blood group is required.");
    if (!personalInfo.religion_id) errors.push("Religion is required.");
    if (personalInfo.category_id === 0) errors.push("Category is required.");
    if (!personalInfo.emp_first_name) errors.push("First name is required.");
    if (!personalInfo.emp_last_name) errors.push("Last name is required.");
    if (!personalInfo.age) errors.push("Age is required.");
    if (personalInfo.married_flag === null)
      errors.push("Marital status is required.");
    if (!personalInfo.fathers_name) errors.push("Father's name is required.");

    if (!address.loc_add1) errors.push("Local address is required.");
    if (address.loc_city_id === null) errors.push("Local city is required.");
    if (!address.perm_add1) errors.push("Permanent address is required.");
    if (!address.perm_city_id) errors.push("Permanent city is required.");
    if (address.prim_mob_no === null)
      errors.push("Primary mobile number is required.");

    if (!jobDetails.staff_number) errors.push("Staff number is required.");
    if (!jobDetails.hire_date) errors.push("Hire date is required.");
    if (jobDetails.department_id === null)
      errors.push("Department is required.");
    if (jobDetails.grade_id === null) errors.push("Grade is required.");
    if (jobDetails.designation_id === null)
      errors.push("Designation is required.");
    if (!jobDetails.emp_type) errors.push("Employee type is required.");
    if (!jobDetails.status) errors.push("Status is required.");
    if (jobDetails.manager_emp_id === null)
      errors.push("Manager Employee ID is required.");

    return errors;
  };

  // const handleCancel = () => {
  //   Swal.fire({
  //     title: "Are you sure you want to cancel?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "No",
  //     confirmButtonColor: "rgb(100 101 101)",
  //     cancelButtonColor: "#318682",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       resetForm();
  //     }
  //   });
  // };

  const handleCancel = () => {
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>Your changes will be lost. Do you want to continue?</span>
        </div>

        <div
          className="messagebox-insider2"
          style={{ display: "flex", gap: "10px", marginTop: "10px" }}
        >
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              setIsMessageBoxVisible(false);
              // proceed with cancel
              resetForm(); // this already reloads after 1s in your code
            }}
          >
            YES
          </button>

          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              // just close the box
              setIsMessageBoxVisible(false);
            }}
          >
            NO
          </button>
        </div>
      </div>
    );
    setActiveImg(WarnningIcon);
    setIsMessageBoxVisible(true);
    setMessageBoxHeight("10vh");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const resetForm = () => {
    setPersonalInfo({});
    setJobDetails({});
    setAddress({});
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  return (
    <div className="create-role-container">
      <div className="create-role-container-one">
        <span className="create-role-heading">Employee Registration Form</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={handleCancel}>
            CANCEL
          </button>
          <button
            className="cr-create-btn"
            onClick={handleSubmit}
            style={{ backgroundColor: "#424342", color: "white" }}
          >
            SAVE
          </button>
        </div>
      </div>

      <PersonalInfo setPersonalInfo={setPersonalInfo} />
      <Address setAddress={setAddress} />
      <JobDetails setJobDetails={setJobDetails} />
      <CustomFields />
    </div>
  );
}
export default EmployeeRegistration;
